import { render, staticRenderFns } from "./ActualView.vue?vue&type=template&id=2616b963&"
import script from "./ActualView.vue?vue&type=script&lang=ts&"
export * from "./ActualView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports